<div class="flex flex-col">
  <table mat-table [dataSource]="listItems$">
    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef>Docket</th>
      <td mat-cell *matCellDef="let element">
        <ng-container [ngSwitch]="element.type">
          <ng-container *ngSwitchCase="'repair'">
            <a [routerLink]="['/repair-docket/', element.id]">
              {{ element.title }}
            </a>
          </ng-container>
          <ng-container *ngSwitchCase="'sale'">
            <a [routerLink]="['/sale-docket', element.id]">
              {{ element.title }}</a
            >
          </ng-container>
          <ng-container *ngSwitchCase="'docket'">
            <a [routerLink]="['/docket', element.id]">
              {{ element.title }}
            </a>
          </ng-container>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="customer">
      <th mat-header-cell *matHeaderCellDef>Customer</th>
      <td mat-cell *matCellDef="let element">
        <a [routerLink]="['/customer', element.customer_id]">
          {{ element.customer_name }}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="items">
      <th mat-header-cell *matHeaderCellDef>Items</th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngFor="let item of element.items; let last = last">
          <ng-container *ngIf="last; else notLast">
            {{ item.name }}
          </ng-container>
          <ng-template #notLast> {{ item.name }}, </ng-template>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef>Date</th>
      <td mat-cell *matCellDef="let element">
        {{ element.date | amDateFormat : dateFormat }}
      </td>
    </ng-container>

    <ng-container matColumnDef="balance">
      <th mat-header-cell *matHeaderCellDef>Outstanding</th>
      <td mat-cell *matCellDef="let element">
        {{ element.balance | hlCurrency | async }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let row; columns: columns"></tr>
  </table>
</div>
